import { TipoMensajeModal } from '../enum/enumTipoMensajeModal';
import { TipoAlerta } from '../enum/enumTipoAlerta';
import { AccionBoton } from '../enum/enumAccionBoton';

export class MensajeModal {
    mensaje: string;
    mensajeCupo: string;
    tipoModal: TipoMensajeModal;
    tituloBotonPrimario: string;
    tituloBotonSecundario: string;
    tituloBotonLink: string;
    icono?: string;
    conservarDespuesCambioRuta: boolean;
    tipoMensajeAlerta: TipoAlerta;
    accionBoton: AccionBoton;
    accionBotonSecundaria?: AccionBoton;
    url?: string;
    statusCode?: number = 0;
    exceptionType?: string;
    constructor(init?: Partial<MensajeModal>) {
        Object.assign(this, init);
    }
}
